

import { defineComponent} from 'vue'
import {SocialNetworks} from '@/components/molecules'

export default defineComponent({
  components: {SocialNetworks}
})
